<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.copySchedule') }}
			</div>
			<v-row> </v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<Dropdown
					v-model="plannedCourse"
					:ajax="true"
					:data="'planned-courses2/' + $route.params.id"
					:errorBorder="!plannedCourseValidation"
					:label="'* ' + $t('fields.plannedCourse')"
				></Dropdown>
			</v-col>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="copyClick">
					{{ $t('buttons.choose') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-if="showModal">
			<Modal :show-modal="showModal">
				<CopySchedule
					:courseId="courseId"
					:currentAppointment="schedule[this.appointmentIndex]"
					:counter="appointmentIndex + 1"
					:length="schedule.length"
					@save="appointmentSaved"
					@skip="skipClick"
					@close="closeModal"
				></CopySchedule>
			</Modal>
		</v-row>
	</div>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import Modal from '../../trinkets/Modal';
import CopySchedule from './CopySchedule';

export default {
	name: 'CopyScheduleFrom',
	components: { Dropdown, CopySchedule, Modal },
	props: {
		courseId: [Number, String],
	},
	emits: ['close'],
	data() {
		return {
			plannedCourse: null,
			plannedCourseValidation: true,
			schedule: [],
			showModal: false,
			appointmentIndex: 0,
		};
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		closeModal() {
			if (this.schedule.length == this.appointmentIndex + 1) {
				this.appointmentIndex = 0;
			}
			this.showModal = false;
			this.plannedCourse = null;
			this.$emit('close');
		},
		appointmentSaved() {
			if (this.schedule.length == this.appointmentIndex + 1) {
				this.appointmentIndex = 0;
				this.plannedCourse = null;
				this.showModal = false;
				this.$emit('close');
			} else {
				this.appointmentIndex++;
				this.showModal = true;
			}
		},
		skipClick() {
			this.appointmentIndex++;
			this.showModal = true;
		},
		copyClick() {
			let success = true;

			if (!this.plannedCourse) {
				success = false;
				this.plannedCourseValidation = false;
			} else {
				this.plannedCourseValidation = true;
			}

			if (success) {
				let vm = this;
				this.$APICall(
					'get',
					'planned-courses/copy-schedule/' + this.plannedCourse + '/' + this.$route.params.id,
					null,
					(data, success) => {
						if (success) {
							let usableData = JSON.parse(JSON.stringify(data));
							vm.schedule = usableData;
							if (vm.schedule.length <= 0) {
								vm.$alert(vm.$t('alerts.selectedPlannedCourseNoAppointments'));
							} else {
								vm.showModal = true;
							}
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				);
			}
		},
	},
};
</script>
